export default {"src":"/_next/static/media/linkedin.d0633ae1.svg","height":16,"width":16};